import { siteMetadata } from 'data/siteMetadata';

import type { BuildLinksProps } from './buildLinks';

interface HreflangLinkProps
  extends Pick<BuildLinksProps, 'currentPath' | 'currentLocale' | 'availableLocales'> {
  path: string;
}

const euHreflangs = [
  'en-nl',
  'en-pt',
  'en-it',
  'en-ie',
  'en-es',
  'en-be',
  'en-de',
  'en-fr',
  'en-at',
  'en-mt',
  'en-lu',
  'en-cy',
  'en-fi',
  'en-ee',
  'en-sk',
  'en-gr',
  'en-si',
  'en-hr',
  'en-lv',
  'en-lt',
  'en-cz',
  'en-dk',
  'en-ro',
  'en-bg',
  'en-hu',
  'en-pl',
  'en-se',
];

export const buildHreflangLinks = ({
  currentPath,
  currentLocale,
  availableLocales,
  path,
}: HreflangLinkProps) => {
  if (currentPath.includes('/blog/') || currentPath.includes('/help/')) return [];

  const euHrefLangLinks = euHreflangs.map(hrefLang => {
    if (currentPath.includes('/404/') || currentPath.includes('/survey-thanks/')) {
      return {
        rel: 'alternate',
        hrefLang,
        href: `${siteMetadata.siteUrl}${path}`,
      };
    }
    return {
      rel: 'alternate',
      hrefLang,
      href: `${siteMetadata.siteUrl}/eu${path}`,
    };
  });

  const alternateLinks = availableLocales
    .filter(
      locale =>
        locale.lang !== 'en' &&
        locale.lang.toLowerCase() !== 'en-eu' &&
        locale.lang !== currentLocale.lang
    )
    .map(locale => {
      const href = path
        ? `${siteMetadata.siteUrl}/${locale.path}${path}`
        : `${siteMetadata.siteUrl}/${locale.path}/`;

      return {
        rel: 'alternate',
        hrefLang: locale.lang.toLowerCase(),
        href,
      };
    });

  const currentHrefLangLink =
    currentLocale.lang.toLowerCase() !== 'en-eu'
      ? [
          {
            rel: 'alternate',
            hrefLang: currentLocale.lang.toLowerCase(),
            href: `${siteMetadata.siteUrl}${currentPath}`,
          },
        ]
      : [];

  return [
    ...currentHrefLangLink,
    ...euHrefLangLinks,
    ...alternateLinks,
    { rel: 'alternate', hrefLang: 'x-default', href: `${siteMetadata.siteUrl}${path}` },
  ];
};
